"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuizzCell;
function QuizzCell(_ref) {
  var cell = _ref.cell,
    uriTransformer = _ref.uriTransformer,
    showProduct = _ref.showProduct,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage;
  return /*#__PURE__*/React.createElement("div", null);
}